import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import ClickNHold from "react-click-n-hold";
import { accounts } from "../../services/services";
import AccountsModal from "./AccountsModal";

class NavBottom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path_url: window.location.pathname,
      accounts: null,
      user: null,
      accounts_modal: false,
      redirect: false,
    };
  }
  get_accounts() {
    accounts().then((items) => {
      items &&
        this.setState({
          accounts: items.shops,
          user: items.user,
        });
    });
  }
  render() {
    return (
      <div className="container" dir="rtl">
        {this.state.redirect && <Redirect push to="/profile" />}

        <div
          className="row mx-0 text-center position-fixed py-1 px-2 shadow-lg bg-white nav_bottom"
          style={{ height: "65", bottom: "0", right: "0", left: "0" }}
        >
          <div className="col p-2">
            <Link to="/" className="btn p-0 mt-1">
              <span className="btn p-0">
                <img
                  alt="shop-home-icon"
                  className="mb-1"
                  width="22"
                  src={
                    require(`../../../base/assets/icons/user-home${
                      this.state.path_url === "/" ? "-fill" : ""
                    }-icon.svg`).default
                  }
                />
                <span
                  className={`fs-7 d-block fw-bold ${
                    this.state.path_url === "/"
                      ? "color-main"
                      : "text-secondary"
                  }`}
                >
                  خانه
                </span>
              </span>
            </Link>
          </div>

          <div className="col p-2">
            <Link to="/categories" className="btn p-0 mt-1">
              <span className="btn p-0">
                <img
                  alt="management-categories-icon"
                  className="mb-1"
                  width="22"
                  src={
                    require(`../../../base/assets/icons/management-products${
                      this.state.path_url.includes("categories") ? "-fill" : ""
                    }-icon.svg`).default
                  }
                />
                <span
                  className={`fs-7 d-block fw-bold ${
                    this.state.path_url.includes("categories")
                      ? "color-main"
                      : "text-secondary"
                  }`}
                >
                  دسته ها
                </span>
              </span>
            </Link>
          </div>

          <div className="col p-2">
            <Link to="/carts" className="btn p-0 mt-1">
              <span className="btn p-0">
                <img
                  alt="shop-carts-icon"
                  className="mb-1"
                  width="22"
                  src={
                    require(`../../../base/assets/icons/user-carts${
                      this.state.path_url === "/carts" ? "-fill" : ""
                    }-icon.svg`).default
                  }
                />
                <span
                  className={`fs-7 d-block fw-bold ${
                    this.state.path_url === "/carts"
                      ? "color-main"
                      : "text-secondary"
                  }`}
                >
                  سبد خرید
                </span>
              </span>
            </Link>
          </div>

          <div className="col p-2">
            <ClickNHold
              className="btn p-0 mt-1"
              time={0.5}
              onEnd={() => {
                this.state.accounts_modal === false &&
                  this.setState({ redirect: true });
              }}
              onClickNHold={() => {
                this.get_accounts();
                this.setState({ accounts_modal: true });
              }}
            >
              <span className="btn p-0">
                <img
                  alt="shop-profile-icon"
                  className="mb-1"
                  width="22"
                  src={
                    require(`../../../base/assets/icons/user-profile${
                      this.state.path_url === "/profile" ? "-fill" : ""
                    }-icon.svg`).default
                  }
                />
                <span
                  className={`fs-7 d-block fw-bold ${
                    this.state.path_url === "/profile"
                      ? "color-main"
                      : "text-secondary"
                  }`}
                >
                  پروفایل
                </span>
              </span>
            </ClickNHold>
          </div>
        </div>
        {this.state.accounts_modal && (
          <AccountsModal
            changeModal={(value) => this.setState({ accounts_modal: value })}
            accounts_modal={this.state.accounts_modal}
            accounts={this.state.accounts}
            user={this.state.user}
          />
        )}
      </div>
    );
  }
}

export default NavBottom;
